import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1466">
      <Hero data-id="element-1467" />
      <LocalTrust data-id="element-1468" />
      <Services data-id="element-1469" />
      <HowItWorks data-id="element-1470" />
      <FAQ data-id="element-1471" />
      <Reviews data-id="element-1472" />
    </main>;
}